import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-driver-wrapper',
  templateUrl: './driver-wrapper.component.html',
  styleUrls: ['./driver-wrapper.component.css']
})
export class DriverWrapperComponent implements OnInit {
  isDriverLoadV1 = false;
  subMenu = 'V1';
  constructor() { }

  ngOnInit() {
  }

  onSelectSubMenu(menu) {
    this.subMenu = menu;
    if (this.subMenu === 'V2') {
      this.isDriverLoadV1 = false;
    }
  }
  ngOnDestroy(): void {
    
  }
}
